import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@gisatcz/ptr-atoms';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Screen = function Screen(_ref) {
  var content = _ref.content,
      disabled = _ref.disabled,
      focused = _ref.focused,
      onFocus = _ref.onFocus,
      onCloseClick = _ref.onCloseClick,
      onOpenClick = _ref.onOpenClick,
      onRetractClick = _ref.onRetractClick,
      noControls = _ref.noControls,
      lineage = _ref.lineage,
      minWidth = _ref.minWidth,
      width = _ref.width;
  var screen = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focusedState = _useState2[0],
      setFocused = _useState2[1];

  var onFocusSelf = function onFocusSelf() {
    if (!disabled) {
      onFocus(lineage);
      setFocused(true);
    }
  };

  var onBlur = function onBlur() {
    setFocused(false);
  };

  useEffect(function () {
    var _screen$current;

    if (disabled !== true && screen !== null && screen !== void 0 && (_screen$current = screen.current) !== null && _screen$current !== void 0 && _screen$current.children[0]) {
      screen.current.children[0].focus();
    }
  }, []);
  var focusRef = useRef();
  useEffect(function () {
    var _screen$current2;

    if (focused && focusRef.current !== focused && !disabled && screen !== null && screen !== void 0 && (_screen$current2 = screen.current) !== null && _screen$current2 !== void 0 && _screen$current2.children[0]) {
      screen.current.children[0].focus();
    }

    focusRef.current = focused;

    if (disabled) {
      setFocused(false);
    }
  }, [focused, disabled]);
  var tabIndex = disabled ? -1 : 0;
  var classes = classNames('ptr-screen', {
    base: lineage === 'base',
    disabled: disabled,
    open: !disabled,
    focused: focusedState
  });
  var screenStyle = {};

  if (width || width === 0) {
    screenStyle.width = "".concat(width, "rem");
  }

  var screenScrollStyle = {};

  if (disabled) {
    screenScrollStyle.overflow = "hidden";
  }

  var screenScrollContentStyle = {};

  if (minWidth || minWidth === 0) {
    screenScrollContentStyle.minWidth = "".concat(minWidth, "rem");
  }

  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    style: screenStyle,
    onFocus: onFocusSelf,
    onBlur: onBlur,
    ref: screen,
    children: [/*#__PURE__*/_jsx("div", {
      className: "ptr-screen-scroll",
      style: screenScrollStyle,
      tabIndex: tabIndex,
      children: /*#__PURE__*/_jsx("div", {
        style: screenScrollContentStyle,
        children: content
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "ptr-screen-overlay",
      onClick: onOpenClick
    }), !noControls ? /*#__PURE__*/_jsx("div", {
      className: "ptr-screen-controls top",
      children: /*#__PURE__*/_jsx(Button, {
        ghost: true,
        icon: 'close',
        side: 'left',
        unfocusable: disabled,
        onClick: onCloseClick
      })
    }) : null, !noControls && disabled ? /*#__PURE__*/_jsx("div", {
      className: "ptr-screen-controls middle",
      children: /*#__PURE__*/_jsx(Button, {
        ghost: true,
        icon: 'chevron-left',
        side: 'left',
        unfocusable: disabled,
        onClick: onOpenClick
      })
    }) : null, !noControls && !disabled ? /*#__PURE__*/_jsx("div", {
      className: "ptr-screen-controls middle",
      children: /*#__PURE__*/_jsx(Button, {
        ghost: true,
        icon: 'chevron-right',
        side: 'left',
        unfocusable: disabled,
        onClick: onRetractClick
      })
    }) : null]
  });
};

Screen.propTypes = {
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  onFocus: PropTypes.func,
  onCloseClick: PropTypes.func,
  onOpenClick: PropTypes.func,
  onRetractClick: PropTypes.func,
  noControls: PropTypes.bool,
  lineage: PropTypes.string,
  minWidth: PropTypes.number,
  width: PropTypes.number
};
export default Screen;